var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnderline = function SvgUnderline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    style: {
      color: "#6a89a6"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.89 23.5a.89.89 0 0 1-.89.89H11a.89.89 0 0 1 0-1.78h10a.89.89 0 0 1 .89.89Zm-2.168-3.778A5.271 5.271 0 0 1 16 21.266 5.271 5.271 0 0 1 10.734 16v-5.625a.89.89 0 1 1 1.782 0V16a3.484 3.484 0 1 0 6.968 0v-5.625a.89.89 0 1 1 1.782 0V16a5.27 5.27 0 0 1-1.544 3.722Z"
  })));
};
export default SvgUnderline;